<script>
	import { onMount } from 'svelte';
	import { auth, user } from './stores.js';
	import Signin from './Signin.svelte';
	import Dashboard from './Dashboard.svelte';

	let status ="";

	$auth.onAuthStateChanged(function(userAuthState) {
		if(userAuthState){
			// console.log('onAuthStateChanged user: ',userAuthState);
			$user = userAuthState;
			console.log('user: ', $user);

		} else {
			// console.log('onAuthStateChanged no user');
			$user = null;
		};
	});

	onMount( async() => {
        if ($auth.isSignInWithEmailLink(window.location.href)){
            let storedEmail = window.localStorage.getItem('emailForSignIn');
            if (!email) {
                storedEmail = window.prompt('Please provide your email for confirmation');
            }
            $auth.signInWithEmailLink(storedEmail, window.location.href)
                .then(function(result) {
                    window.localStorage.removeItem('emailForSignIn');
                    console.log('user: ', result.user);
                    console.log('additional info: ',result.additionalUserInfo.profile);
                    console.log('new user: ',result.additionalUserInfo.isNewUser);
                })
                .catch(function(error){
                    status = error.code;
                });
		}
		console.log('url: ',window.location.href);
		console.log('auth: ',$auth);
    });

</script>

<main>
	{#if $user}
		<button id="logout" on:click={ () => $auth.signOut() }>Logout</button>
		<Dashboard />
	{:else}
		<Signin status={status} />
	{/if}
</main>

<style>
	main {
		text-align: center;
		/* padding: 1em; */
		/* max-width: 240px; */
		margin: 0 auto;
	}

	/* h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	} */

	#logout {
		position: absolute;
		top: 0;
		right: 0;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>